import React from "react";
import AsyncComponent from "../../../components/async-component";
import PageWrap from "../../../components/page-wrap";
import PageContent from "../../../components/page-content";
import { updateBreadcrumb } from "../../../utils/breadcrumbs";
import { PriceListProvider } from "./context/price-list-context";

class PriceListPage extends React.Component {
    componentDidMount = updateBreadcrumb;

    render() {
        return (
            <PageWrap>
                <PageContent>
                    <PriceListProvider>
                        <AsyncComponent component={() => import("./content")} />
                    </PriceListProvider>
                </PageContent>
            </PageWrap>
        );
    }
}

export default PriceListPage;
